<template>
    <div class="stores">
        <div class="stores-map">
            <baidu-map class="bm-view" ak="Us1CNdAWY0f9gd66R28v3s6SmkLg694W" :center="{lng: map.center.lng, lat: map.center.lat}" :zoom="16" :scroll-wheel-zoom="true">
                <!--缩放控件-->
                <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_LEFT" ></bm-navigation>
                <!--聚合动态添加的点坐标-->
                <bm-marker-clusterer :averageCenter="true">
                    <bm-marker v-for="marker of markers" :key="marker.code" :position="{lng: marker.lo, lat: marker.la}" :icon="{url: require('../assets/icon.png'), size: {width: 55, height: 55}}" @click="lookDetail(marker)"></bm-marker>
                </bm-marker-clusterer>
                <bm-info-window :position="{lng: infoWindow.info.lo, lat: infoWindow.info.la}" :title="infoWindow.info.name" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen">
                    <p><span class="left">地址：</span><span class="right">{{infoWindow.info.address}}</span></p>
                    <p><span class="left">电话：</span><span class="right">{{infoWindow.info.phone2}}</span></p>
                </bm-info-window>
            </baidu-map>
            <div id="allmap" hidden="true"></div>
        </div>
        <div class="stores-list">
            <div>
                <p>查询线下门店</p>
                <div class="stores-area">
                    <el-select v-model="provinceObj" placeholder="请选择省" @change="provinceChange" value-key="name" style="width:45%;margin-right: 1rem;">
                        <el-option v-for="(item, index) in provinceData" :key="index" :label="item.name" :value="item"></el-option>
                    </el-select>
                    <el-select v-model="cityObj" placeholder="请选择市" @change="cityChange" value-key="name" style="width:45%;">
                        <el-option v-for="(item, index) in cityData" :key="index" :label="item.name" :value="item"></el-option>
                    </el-select>
                </div>
                <p class="nearStores">
                    <img src="../assets/nearby-stores.png" alt="">
                    查找附近门店
                </p>
            </div>
            <div>
                <p class="store-list-box">门店列表</p>
                <div class="stores-box" v-show="storesData.length != 0">
                    <div class="store-list" v-for="(item,index) in storesData" :key="index" @click="lookDetail(item, 'right')">
                        <p class="store-title">布瑞琳{{item.name}}</p>
                        <p class="store-address">{{item.address}}</p>
                        <p class="store-phone">电话： {{item.phone2}}</p>
                    </div>
                </div>
                <div class="stores-box" style="display: flex;justify-content: center;align-items: center;" v-show="storesData.length == 0">
                    <div>敬请期待</div>
                </div>
            
            </div>
        </div>
    </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmScale from 'vue-baidu-map/components/controls/Scale';
import BmNavigation from 'vue-baidu-map/components/controls/Navigation';
import BmMarkerClusterer from  'vue-baidu-map/components/extra/MarkerClusterer';
import BmMarker from 'vue-baidu-map/components/overlays/Marker';
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow';
import gcoord from 'gcoord'

export default {
    name: "pm-distribution",
    components: {
        BaiduMap,
        BmScale,
        BmNavigation,
        BmMarkerClusterer,
        BmMarker,
        BmInfoWindow
    },
    data(){
        return{
            map:{center:{lng: 116.4, lat: 39.9}},
            markers:[],
            // markers:[
            //     {lng: 116.4, lat: 39.9},
            // ],

            provinceObj: {name: ''},
            cityObj: {name: ''},
            // provinceData: ProvinceCityCountry.address,
            provinceData: [],
            cityData: [],
            storesData:[],
            infoWindow: {
                show: false,
                info: {},
            },
        }
    },
    created(){
        this.$fetch("store/fetch",{}).then(res => {
            this.storesData = res;
            this.markers = res;
        })
        this.$fetch("store/select/province").then(res => {
            console.log('store/select/province',res);
            this.provinceData = res.data;
        })
    },

    methods:{
        provinceChange(value){
            this.cityData = value.children  // 市下拉列表
            this.countryData = []  // 清空区县下拉列表数据
            this.cityObj = {} // 清空市输入框内容
        },
        cityChange(value){
            console.log(value);
            // this.countryData = value.children // 县区下拉框列表

            this.$fetch("store/select/city", {id: value.id}).then(res => {
                console.log('store/select/city',res);
                this.storesData = res;
            })
        },
        // specifiedMap(item){
        //     this.map.center={lng: item.lo, lat: item.la};
        // },
        nearbyStores(){
            var that = this
				var map = new BMap.Map("allmap");
				map.enableScrollWheelZoom();
				//得到IP地址经纬度信息				
				function myFun(result) {		
					console.log(result)
					//开启地址检索 --------------Ip地址获取的经纬度信息 写入搜索，以当前经纬度2000为圆圈
					var mPoint = new BMap.Point(result.center.lng, result.center.lat); 
					map.centerAndZoom(mPoint, 12);

                    var resulta = gcoord.transform(
                        [ result.center.lng, result.center.lat ],    // 经纬度坐标
                        gcoord.GCJ02,                 // 当前坐标系
                        gcoord.BD09                   // 目标坐标系
                    );
                    console.log(resulta)

                     that.$fetch("store/nearby/stores", {lo:resulta[0], la:resulta[1], dis: 6}).then(res => {
                        console.log('store/nearby/stores',res);
                        that.storesData = res.data;
                        that.markers = res.data;
                    })
				}
				var myCity = new BMap.LocalCity();
				myCity.get(myFun);

            // const _this = this;
            // // const hide = alert("正在获取当前省市请稍候..", 0);
            // const geolocation = new BMap.Geolocation();

            // geolocation.getCurrentPosition(r => {
            //     // setTimeout(hide, 1000);
            //     console.log(r);

            //     // var result = new BMap.Point(r.point.lng, r.point.lat);

            //     // var resulta = gcoord.transform(
            //     //     [ result.lng, result.lat ],    // 经纬度坐标
            //     //     gcoord.WGS84,                 // 当前坐标系
            //     //     gcoord.BD09                   // 目标坐标系
            //     // );
            //     // console.log('aaaaaaaaaaa',result);
            //     // console.log('aaaaaaaaaaa',resulta);

            //     // _this.$fetch("store/nearby/stores", {lo:r.point.lng, la:r.point.lat,dis:10}).then(res => {
            //     //     console.log('store/nearby/stores',res);
            //     // })

            //     },{ enableHighAccuracy: true }
            // )



            // var geolocation = new BMap.Geolocation();
            // geolocation.getCurrentPosition(function(r){
            //     if(this.getStatus() == BMAP_STATUS_SUCCESS){
            //         console.log(r.point.lng, r.point.lat)
            //         var result = gcoord.transform(
            //             [ r.point.lng, r.point.lat ],    // 经纬度坐标
            //             gcoord.WGS84,                 // 当前坐标系
            //             gcoord.BD09                   // 目标坐标系
            //         );
            //         console.log('aaaaaaaaaaaaaa',result)
            //         // console.log('11111111111111', this.bd09togcj02(r.point.lng, r.point.lat));
            //         // console.log(r);
            //     }else {
            //         console.log('failed'+this.getStatus());
            //     }
            // });
            
            // //坐标转换完之后的回调函数
            // setTimeout(()=>{
            //     var convertor = new BaiduMap.Convertor();
            //     var pointArr = [];
            //     pointArr.push(ggPoint);
            //     convertor.translate(pointArr, 1, 5, translateCallback)
            // }, 1000);

            
        },
        lookDetail(data, target){
            console.log(data,target);
            this.infoWindow.show =true;
            this.infoWindow.info=data;
            // this.activeName = data.name;
            // //为弹窗口标题添加title
            // this.$nextTick(()=>{
            //     var win=document.querySelector(".BMap_bubble_title");
            //     win.title = this.activeName;
            // })
            if(target=='right'){ //点击的是左侧列表项，则不需要滚动
                this.map.center={lng: data.lo, lat: data.la};
                this.map.zoom = 15;
                return;
            }
            // //滚动到指定元素位置
            // this.$nextTick(()=>{
            //     var obj=document.querySelector(".active");
            //     var scrollTop=obj.offsetTop;
            //     this.$refs.box.scrollTop=scrollTop-180;
            // })
        },
        infoWindowClose(e){
            this.infoWindow.show = false;
        },
        infoWindowOpen(e){
            this.infoWindow.show = true;
        }
    },
}
</script>

<style scoped lang="scss">
.stores{
    margin: 2rem 0;
}


.stores-map{
    display: inline-block;
    width: 70%;
    .bm-view {
        width: 100%;
        height: 45rem;
    }
}
.stores-list{
    display: inline-block;
    width: 30%;
    height: 45rem;
    background: #fff;
    float: right;
    text-align: left;
    padding: 1.5rem 3rem 0.5rem 3rem;
    overflow: hidden;

    .stores-area{
        margin: 1rem 0;
    }

    .nearStores{
        font-size: 0.5rem;
        color: #666;

        img{
            width: 0.8rem;
            vertical-align: middle;
            margin-right: 0.8rem;
        }
    }
    
    .store-list-box{
        margin: 2rem 0 1rem;
        font-size: 1.5rem;
    }

    .stores-box{
        height: 31.6rem;
        overflow: auto;
    }
    .store-list{
        border-top: 1px solid #DEDEDE;
        padding: 1rem 0;

        .store-title{
            color: #00146E;
        }
        .store-address{
            margin: 0.2rem 0 0.5rem;
            font-size: 0.6rem;
            color: #666;
        }
        .store-phone{
            font-size: 0.9rem;
        }
    }
}

::v-deep .BMap_bubble_title{
    color: #00146E;
    font-size: 23px;
    font-weight: bolder;
    margin-bottom: 8px;
}

</style>